import React from 'react';
import { CCard, CCardBody } from '@coreui/react';
import { CChart } from '@coreui/react-chartjs';

/**
 * Customers widget showing total customers and growth
 */
const CustomersWidget = () => {
  return (
    <CCard className="customers-widget">
      <CCardBody>
        <div className="widget-content">
          <div className="metric-info">
            <div className="metric-label">Customers</div>
            <div className="metric-value-container">
              <span className="metric-value">424</span>
              <span className="metric-change positive">+3.1%</span>
            </div>
          </div>
          
          <div className="chart-container">
            {/* Background Chart */}
            <div className="chart-layer background">
              <CChart
                type="line"
                height={55}
                data={{
                  labels: Array(13).fill(''),
                  datasets: [{
                    label: 'Previous Month',
                    backgroundColor: 'rgba(35, 132, 2, 0.25)',
                    borderColor: 'rgba(35, 132, 2, 0.25)',
                    pointBackgroundColor: 'transparent',
                    pointBorderColor: 'transparent',
                    tension: 0.4,
                    fill: true,
                    data: [0, 10, 5, 20, 10, 10, 0, 25, 25, 55, 35, 35, 40],
                  }]
                }}
                options={{
                  maintainAspectRatio: false,
                  plugins: { legend: { display: false } },
                  scales: {
                    x: { display: false, grid: { display: false } },
                    y: { display: false, grid: { display: false } }
                  },
                  elements: {
                    line: { borderWidth: 1 },
                    point: { radius: 0 }
                  }
                }}
              />
            </div>
            
            {/* Foreground Chart */}
            <div className="chart-layer foreground">
              <CChart
                type="line"
                height={55}
                data={{
                  labels: Array(14).fill(''),
                  datasets: [{
                    label: 'Current Month',
                    backgroundColor: 'transparent',
                    borderColor: 'var(--cui-primary)',
                    pointBackgroundColor: 'transparent',
                    pointBorderColor: 'transparent',
                    tension: 0.4,
                    data: [15, 20, 20, 0, 15, 30, 30, 55, 45, 45, 35, 50, 45, 55],
                  }]
                }}
                options={{
                  maintainAspectRatio: false,
                  plugins: { legend: { display: false } },
                  scales: {
                    x: { display: false, grid: { display: false } },
                    y: { display: false, grid: { display: false } }
                  },
                  elements: {
                    line: { borderWidth: 2 },
                    point: { radius: 0 }
                  }
                }}
              />
            </div>
          </div>
        </div>
      </CCardBody>
    </CCard>
  );
};

export default CustomersWidget; 